import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Tooltip } from '@telus-uds/components-web';

import Overlay from './overlay';

const DisableButton = ({ email, fetchData }) => {
  const [inDisableMode, setInDisableMode] = useState(false);

  return (
    <>
      <Tooltip content="Disable">
        <button
          className="disableButtonMain"
          type="button"
          onClick={() => {
            setInDisableMode(true);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1}
            stroke="currentColor"
            className="disableButton"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
            />
          </svg>
        </button>
      </Tooltip>
      {inDisableMode && (
        <Overlay
          email={email}
          fetchData={fetchData}
          setInDisableMode={setInDisableMode}
        />
      )}
    </>
  );
};

DisableButton.propTypes = {
  email: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default DisableButton;
